import React from 'react';
import Loadable from 'react-loadable';
import LinearProgress from '@material-ui/core/LinearProgress';
import { useSelector } from 'react-redux';

import { selectUser } from 'entities/user/selectors';
import { Features } from 'utils/features';

const createLoadable = (loader: Promise<any>) =>
  Loadable({
    // eslint-disable-next-line no-console
    loader: () =>
      loader
        .then((module) => module.default || module)
        .catch(() => console.error('Failed to load dashboard')),
    loading: () => <LinearProgress />,
  });

const ReportsBasic = createLoadable(import('../ReportsBasicPage'));
const ReportsAdvanced = createLoadable(import('../ReportsAdvancedPage'));

export default () => {
  const user = useSelector(selectUser);

  const useAdvancedReporting = user?.hasFeature(Features.ADVANCED_REPORTING);

  if (useAdvancedReporting) {
    return <ReportsAdvanced />;
  } else {
    return <ReportsBasic />;
  }
};
